__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "af-broker-shell-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "2.37.0", () => (() => (__webpack_require__(7435))), 1);
			register("@azure/msal-common", "13.0.0", () => (() => (__webpack_require__(7045))), 1);
			register("@azure/msal-react", "1.5.7", () => (Promise.all([__webpack_require__.e(639), __webpack_require__.e(166), __webpack_require__.e(895)]).then(() => (() => (__webpack_require__(9639))))));
			register("@emotion/react", "11.11.3", () => (Promise.all([__webpack_require__.e(973), __webpack_require__.e(166), __webpack_require__.e(76)]).then(() => (() => (__webpack_require__(1973))))));
			register("@sgi/af-shell-shared", "0.1.47", () => (Promise.all([__webpack_require__.e(313), __webpack_require__.e(166), __webpack_require__.e(51), __webpack_require__.e(895), __webpack_require__.e(155), __webpack_require__.e(20), __webpack_require__.e(893)]).then(() => (() => (__webpack_require__(8666))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(166)]).then(() => (() => (__webpack_require__(3935))))));
			register("react-router-dom", "6.21.2", () => (Promise.all([__webpack_require__.e(818), __webpack_require__.e(166), __webpack_require__.e(51)]).then(() => (() => (__webpack_require__(9818))))));
			register("react", "18.2.0", () => (() => (__webpack_require__(7294))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};